/**
 *
 * FBFormsAnswer
 *
 */

import React, { memo, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Radio, Input, Checkbox, Button } from 'antd';
const { TextArea } = Input;
// layout components
import ErrorBoundary from 'engine/ErrorBoundary';
import Preloader from 'components/Preloader';
// components
import HiddenField from 'components/Forms/Fields/HiddenField';
// inner communication components 
import {
  FBMobileSectionHeader,
  FBMobileWrapper,
} from 'mobile/components/Communications';


function FBFormsAnswer({
  form,
  showHeader,
  showWrapper,
  type,
  forms,
  values,
  actionRequired,
  loading,
  hideActions,
  // actions
  onSubmit,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-forms-group-preview', 'tcf-fb-group-preview', className);

  const [previewForm] = Form.useForm();
  const mainForm = !!form && form || previewForm;
  const formName = type;

  const [answers, setAnswers] = useState(values || []);

  // Refresh current value based on parent`s states
  useEffect(() => {
    if (!!values && JSON.stringify(values) != JSON.stringify(answers)) {
      setAnswers(values || []);
    } else if (!!!values) {
      setAnswers({});
      mainForm.resetFields();
    }
  }, [values]);

  const prepearGroup = useCallback((fields, type) => {
    let gruopOptions = [];
    if (!!fields?.['field-input'] && type) {
      gruopOptions = fields?.['field-input']?.map((opt, indx) => {
        const label = opt?.[`${type}-input`];
        return {
          label,
          value: label,
          key: indx
        }
      })
    }
    return gruopOptions;
  }, [])

  const generatePreviewByType = useCallback((row, name) => {
    switch (row['field-type']) {
      case 'textarea':
        return (
          <>
            <Form.Item
              name={[name, [`${row['field-type']}-answer`]]}
              key={[name, [`${row['field-type']}-answer`]]}
              className="forms-field"
              rules={[
                {
                  required: true,
                  message: 'Champ obligatoire',
                },
              ]}
            >
              <TextArea
                row="4"
                placeholder={`Réponse gratuite`}
              />
            </Form.Item>
          </>
        );

      case 'checkbox':
        const checkboxOptions = prepearGroup(row, 'checkbox')
        return (
          <>
            <Form.Item
              name={[name, [`${row['field-type']}-answer`]]}
              key={[name, [`${row['field-type']}-answer`]]}
              className="forms-field"
              rules={[
                {
                  required: true,
                  message: 'Champ obligatoire',
                },
              ]}
            >
              <Checkbox.Group
                options={checkboxOptions}
              />
            </Form.Item>
          </>
        );

      case 'radio':
        const radioOptions = prepearGroup(row, 'radio')
        return (
          <>
            <Form.Item
              name={[name, [`${row['field-type']}-answer`]]}
              key={[name, [`${row['field-type']}-answer`]]}
              className="forms-field"
              rules={[
                {
                  required: true,
                  message: 'Champ obligatoire',
                },
              ]}
            >
              <Radio.Group
                options={radioOptions}
              />
            </Form.Item>
          </>
        );

      case 'input':
        return (
          <>
            <Form.Item
              name={[name, [`${row['field-type']}-answer`]]}
              key={[name, [`${row['field-type']}-answer`]]}
              className="forms-field"
              rules={[
                {
                  required: true,
                  message: 'Champ obligatoire',
                },
              ]}
            >
              <Input placeholder={`Courte réponse`} />
            </Form.Item>
          </>
        );

      default: <></>;
    }
  }, [answers])

  // Update parent states based on changes inside Form
  const handleValuesChange = useCallback((changedValues, allValues) => {
    //  console.log('handleValuesChange', { changedValues, allValues, answers });
    //  setAnswers(allValues);
  }, [])

  const onSubmitHandle = useCallback((data) => {
    setAnswers(data);
    !!onSubmit && onSubmit(data, formName);
  }, [values]);

  const onFinishFailed = errorInfo => {
    console.error('Failed FBFormsAnswer:', errorInfo);
  };

  const RenderComponent = ({ children }) => !!showWrapper ? (
    <>
      <FBMobileWrapper
        key="forms-wrapper"
        className={childClassNames}
        showHeader={showHeader}
        types={["forms"]}
        loading={loading}
      >
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      </FBMobileWrapper>
    </>
  ) : (
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  );

  return !!forms && (
    <RenderComponent>
      <Form
        name={formName}
        form={mainForm}
        initialValues={{ ...answers }}
        className="tcf-fb-forms-answer"
        autoComplete="off"
        onValuesChange={handleValuesChange}
        onFinish={onSubmitHandle}
        onFinishFailed={onFinishFailed}
        disabled={loading || !!values || !actionRequired}
      >
        {showHeader && (
          <div className='form-header'>
            {!!forms[`${type}-title`] && (
              <h3 className="form-title">{forms[`${type}-title`]}</h3>
            )}
            {!!forms[`${type}-description`] && (
              <p className="form-description">{forms[`${type}-description`]}</p>
            )}
          </div>
        )}
        {forms[`${type}-fields`]?.map((row, indx) => {
          return !!row && (
            <div key={`form-answ--row${indx}`} className='form-row'>
              <h4 className={`form-row__title ${row[`field-type`]}`}>{row[`field-title`]}</h4>
              <div className='form-row__field'>
                <HiddenField
                  key={[indx, `field-type`]}
                  data={{ name: [indx, `field-type`] }}
                  index={0}
                  value={row['field-type']}
                />
                <HiddenField
                  key={[indx, `field-title`]}
                  data={{ name: [indx, `field-title`] }}
                  index={0}
                  value={row['field-title']}
                />
                {generatePreviewByType(row, indx)}
              </div>
            </div>
          );
        })}
        {!!!hideActions && actionRequired && !values && (
          <div className="actions-wrapper">
            <Button className="btn-previous" onClick={() => {
              mainForm.resetFields();
              setAnswers({});
            }}>
              Annuler
            </Button>
            <Button
              className="confirm-btn"
              form={formName}
              htmlType="submit"
            >
              Envoyer
            </Button>
          </div>
        )}
      </Form>
    </RenderComponent>
  );
}

FBFormsAnswer.defaultProps = {
  type: 'forms',
  form: null,
  actionRequired: true,
  showWrapper: true,
  showHeader: true
};
FBFormsAnswer.propTypes = {
  forms: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.array]),
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.array]),
  onSubmit: PropTypes.func
};

export default memo(FBFormsAnswer);
